import { useUIStore } from '@uofu-uss-gis/ui-react';
import { useAuthStore } from '../../store/authStore';
import { env } from '../../config/env';
import MyClassesList from './MyClassesList';
import MyClassDetail from './MyClassDetail';
import { useTheme } from '@mui/material/styles';

const isLocalMode = env.localMode;

const MyClassesPanel = () => {
  const { isAuthenticated } = useAuthStore();
  const { myClassesOpen, myClassesDetailOpen } = useUIStore();
  const theme = useTheme();

  if (!isAuthenticated && !isLocalMode) {
    return null;
  }

  if (!myClassesOpen && !myClassesDetailOpen) {
    return null;
  }

  return (
    <div 
      className="absolute inset-0 lg:inset-auto lg:top-32 lg:right-4 lg:w-80 shadow-lg lg:rounded-lg z-[1000] h-full lg:h-auto lg:max-h-[calc(100vh-9rem)] overflow-hidden"
      style={{ backgroundColor: theme.palette.background.paper }}
    >
      {myClassesDetailOpen ? <MyClassDetail /> : <MyClassesList />}
    </div>
  );
};

export default MyClassesPanel;
